import request from './request'



export function getQrCode(query) {
    return request({
        url: '/download/qrcode',
        method: 'post',
        data: query
    });
}

export function postSmsCode(query){
    return request({
        url: '/push/sms',
        method: 'post',
        data: query
    });
}

export function postLogin(query){
    return request({
        url: '/user/login',
        method: 'post',
        data: query
    });
}

export function postMyInfo(query){
    return request({
        url: '/user/info',
        method: 'post',
        data: query
    });
}

export function postMyAppointments(query){
    return request({
        url: '/user/appointment/list',
        method: 'post',
        data: query
    });
}
export function postSaveInfo(query){
    return request({
        url: '/user/improveinfo',
        method: 'post',
        data: query
    });
}

export function getsdk(query){
    return request({
        url: '/download/sdk',
        method: 'get',
        data: query
    });
}

export function postSdkMenu(query){
    return request({
        url: '/word/menu',
        method: 'post',
        data: query
    });
}

export function postSdkContent(query){
    return request({
        url: '/word/content',
        method: 'post',
        data: query
    });
}

export function getskuList(queryId){
    return request({
        url: '/product/sku/list/'+queryId,
        method: 'get',
        data: null
    });
}

export function postAppointmentAdd(query){
    return request({
        url: '/user/appointment/add',
        method: 'post',
        data: query
    });
}

export function postAppointmentTouristAdd(query){
    return request({
        url: '/user/appointment/tourist/add',
        method: 'post',
        data: query
    });
}

export function ConsultAdd(query){
    return request({
        url: '/consult/add',
        method: 'post',
        data: query
    });
}

export function cancelAppointment(queryId){
    return request({
        url: '/user/appointment/cancel/'+queryId,
        method: 'get',
        data: null
    });
}

export function appSetting(queryId) {
    return request({
        url: '/user/app/setting/'+queryId,
        method: 'get'
    });
}

export function appAdd(query) {
    return request({
        url: '/user/app/add',
        method: 'post',
        data: query
    });
}

export function appModify(query) {
    return request({
        url: '/user/app/modify',
        method: 'post',
        data: query
    });
}

export function appList(query) {
    return request({
        url: '/user/app/list',
        method: 'post',
        data: query
    });
}

export function appFirst(query) {
    return request({
        url: '/user/app/first',
        method: 'post',
        data: query
    });
}

export function appDelete(query) {
    return request({
        url: '/user/app/delete',
        method: 'post',
        data: query
    });
}

export function appPut(query) {
    return request({
        url: '/user/app/put',
        method: 'post',
        data: query
    });
}

export function Videolist(query) {
    return request({
        url: '/user/video/list',
        method: 'post',
        data: query
    });
}

export function addVideo(query) {
    return request({
        url: '/user/video/add',
        method: 'post',
        data: query
    });
}

export function delVideo(query) {
    return request({
        url: '/user/video/delete',
        method: 'post',
        data: query
    });
}

export function GetInstructionsVideos(query) {
    return request({
        url: '/instructions/videos',
        method: 'post',
        data: query
    });
}